import { useQuery } from "@tanstack/react-query";
import { getReportOrderStatusBreakdown } from "../../api/apiReports";

export const useGetReportOrderStatusBreakdown = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-order-status-breakdown", params],
        queryFn: () => getReportOrderStatusBreakdown(params),
        retry: false,
    });

    return {
        items: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
